
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("ffPxZ", function(module, exports) {

$parcel$export(module.exports, "TeamCalendarNavigation", () => $791fef1c51edfb0f$export$a6737a3266096156);
/* TeamCalendarNavigation.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $cGtPE = parcelRequire("cGtPE");

var $3gadb = parcelRequire("3gadb");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $1NBp8 = parcelRequire("1NBp8");

var $jmjWc = parcelRequire("jmjWc");
var $luv00 = parcelRequire("luv00");

var $61vzn = parcelRequire("61vzn");

var $ep3mz = parcelRequire("ep3mz");

var $bQm3c = parcelRequire("bQm3c");

var $euL71 = parcelRequire("euL71");

var $1ytiN = parcelRequire("1ytiN");
const $791fef1c51edfb0f$var$styles = {
    root: "_d16p11wb _1tnq1l7b _1toh1r81 _5jyqagmp _mrqmvv82 _btpd14no _oiqe14no _1i92dlk8 _z5hhu2gc _16hg18uv _u1mb166n _1w901gjq _1l5a1gjq _zelm1gjq _1f1j1gjq _47lwidpf _1xud1tcg _w2t71tcg _19uagktf _1twxgktf _1mokgktf _175xgktf _128zgktf _18crgktf",
    isSelected: "_16hgfg4m _u1mbi1yw _1w90aqb7 _1l5aaqb7 _zelmaqb7 _1f1jaqb7"
};
const $791fef1c51edfb0f$var$listStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.0'
});

const $791fef1c51edfb0f$var$CalendarIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KFWHm",
    name: "CalendarIcon",
    loader: async ()=>(await (parcelRequire("9Kjca"))).CalendarIcon
});
const $791fef1c51edfb0f$var$i18nTooltips = (0, $2nPZH.defineMessages)({
    calendarsTooltip: {
        id: "side-navigation.space-navigation.calendars.tooltip",
        defaultMessage: "View calendar"
    }
});
const $791fef1c51edfb0f$var$TeamCalendarNavigationComponent = ({ isSelected: isSelected, onClick: onClick })=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        position: "top",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $791fef1c51edfb0f$var$i18nTooltips.calendarsTooltip)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
            as: "li",
            xcss: $791fef1c51edfb0f$var$listStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cGtPE.default), {
            key: "calendars",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($791fef1c51edfb0f$var$CalendarIcon, {
                isSelected: isSelected
            }),
            isSelected: isSelected,
            href: (0, $1NBp8.SPACE_CALENDARS).toUrl({
                spaceKey: spaceKey
            }),
            ...tooltipProps,
            onClick: onClick,
            testId: "space-navigation-calendars-link",
            UNSAFE_shouldDisableRouterLink: true,
            "data-vc": "team-calendar-navigation",
            ...ssrPlaceholderIdProp,
            className: (0, $35pXk.default)([
                $791fef1c51edfb0f$var$styles.root,
                isSelected && $791fef1c51edfb0f$var$styles.isSelected
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
            id: "side-navigation.container.calendars",
            defaultMessage: "Calendars"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $61vzn.PremiumLozengeLoadable), null))));
};
const $791fef1c51edfb0f$export$a6737a3266096156 = (props)=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext)); // Please also update getPremiumFeaturesWebItemKeys() in SpaceNavigation if this condition is updated
    /**
   * showTCNav:
   * - Premium -> true, TC is a premium feature
   * - Standard -> true, iff user is Org/Site Admin, otherwise, false (https://hello.atlassian.net/wiki/spaces/CE2/pages/3031965072/ETC+Standard+P18N+Technical+Spec)
   * - Free -> true, TC upsell to all Free users (https://hello.atlassian.net/wiki/spaces/CE2/pages/2906634153/ETC+P18N+Technical+Spec)
   */ const showTCNav = edition === (0, $euL71.ConfluenceEdition).STANDARD ? isSiteAdmin : true;
    return showTCNav ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($791fef1c51edfb0f$var$TeamCalendarNavigationComponent, props) : null;
};

});
parcelRegister("61vzn", function(module, exports) {

$parcel$export(module.exports, "TrialFlags", () => $5e8e088fe72e4df1$export$c108f21945b8b79);
$parcel$export(module.exports, "PremiumLozengeLoadable", () => $5e8e088fe72e4df1$export$62673719cbe80cd0);
$parcel$export(module.exports, "LazyAutoUpgradeAwarenessModal", () => $5e8e088fe72e4df1$export$212b4f568257f60f);
$parcel$export(module.exports, "ReverseTrialLozengeExperiment", () => $5e8e088fe72e4df1$export$b51195909514673e);
$parcel$export(module.exports, "PremiumLozengeImage", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("leRtl")))));
$parcel$export(module.exports, "useGetUserCount", () => (parcelRequire("dyQkx")).useGetUserCount);

var $gwFzn = parcelRequire("gwFzn");

var $dIouf = parcelRequire("dIouf");

var $jmjWc = parcelRequire("jmjWc");

var $leRtl = parcelRequire("leRtl");

var $dyQkx = parcelRequire("dyQkx");

const $5e8e088fe72e4df1$var$TrialFlagsLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "pBDfE",
    name: "TrialFlagsLoadable",
    loader: async ()=>(await (parcelRequire("hfSv4"))).TrialFlags
});
const $5e8e088fe72e4df1$export$c108f21945b8b79 = (0, $dIouf.withErrorBoundary)({
    attribution: (0, $dIouf.Attribution).GROWTH_LUNA
})(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($5e8e088fe72e4df1$var$TrialFlagsLoadable, null));

const $5e8e088fe72e4df1$export$62673719cbe80cd0 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Txnkb",
    name: "PremiumLozengeLoadable",
    loader: async ()=>(await (parcelRequire("lhVPO"))).PremiumLozenge
});

const $5e8e088fe72e4df1$export$212b4f568257f60f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "E5jvU",
    name: "LazyAutoUpgradeAwarenessModal",
    loader: async ()=>(await (parcelRequire("4R0Br"))).AutoUpgradeAwarenessModal
});

const $5e8e088fe72e4df1$export$b51195909514673e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "EHgbD",
    name: "ReverseTrialLozengeExperiment",
    loader: async ()=>(await (parcelRequire("eeA8N"))).ReverseTrialLozenge
});

});
parcelRegister("leRtl", function(module, exports) {
module.exports = new URL("premiumLozenge.aa9b0435.svg", import.meta.url).toString();

});

parcelRegister("dyQkx", function(module, exports) {

$parcel$export(module.exports, "useGetUserCount", () => $67f403c91a6578ae$export$5106bd0c428c7535);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $diswb = parcelRequire("diswb");

var $7Sm4c = parcelRequire("7Sm4c");
const $67f403c91a6578ae$export$5106bd0c428c7535 = ()=>{
    const { data: data, error: error, loading: loading } = (0, $diswb.useQuery)((0, $d2LG0.default)`query useGetUserCountNumberOfUsersInvitedQuery{license{licenseConsumingUserCount}}`, {
        fetchPolicy: 'cache-and-network'
    });
    if (error && !(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    return {
        error: error,
        loading: loading,
        userCount: data?.license?.licenseConsumingUserCount
    };
};

});

parcelRegister("hfSv4", function(module, exports) {

let $c8fe1cfbeff454a9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $c8fe1cfbeff454a9$var$load("cmcKh"),
    $c8fe1cfbeff454a9$var$load("ktyyJ")
]).then(()=>parcelRequire('1VYG6'));

});

parcelRegister("lhVPO", function(module, exports) {

let $f7f80c459b873240$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $f7f80c459b873240$var$load("4yUSc").then(()=>parcelRequire('9xi4O'));

});

parcelRegister("4R0Br", function(module, exports) {

let $388c94659c0645ac$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $388c94659c0645ac$var$load("4fCJZ"),
    $388c94659c0645ac$var$load("dTsOE"),
    $388c94659c0645ac$var$load("x8U2P")
]).then(()=>parcelRequire('6yR7w'));

});

parcelRegister("eeA8N", function(module, exports) {

let $a5ce6850d4a06c24$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $a5ce6850d4a06c24$var$load("fqBFU").then(()=>parcelRequire('gQsLh'));

});


parcelRegister("9Kjca", function(module, exports) {

let $71874cbb9fd31730$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $71874cbb9fd31730$var$load("aZ9pO").then(()=>parcelRequire('dntIc'));

});



//# sourceMappingURL=TeamCalendarNavigation.88756627.js.map
